import _ from 'lodash'
import { type CustomizerData } from './customizer.client'

export function setPageVariables({
	content,
	vars,
}: {
	content: string
	vars: {
		list?: CustomizerData['list']
		sub?: CustomizerData['sub']
	}
}) {
	const replaceVariables = (
		str: string,
		vars: { [key: string]: any },
	): string => {
		return str.replace(/{{(.*?);(.*?)}}/g, (match, variableId, fallback) => {
			const value = _.get(vars, variableId)
			return value !== undefined ? String(value) : fallback
		})
	}

	return {
		content: replaceVariables(content, vars),
	}
}
